import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import authService from "../../services/authService";
import ThemedSuspense from "./ThemedSuspense";

/**
 * ProtectedRoute Component
 * Guards routes that require authentication
 * Redirects to login if user is not authenticated
 */
const ProtectedRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [isChecking, setIsChecking] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const checkAuth = () => {
      const isValid = authService.isAuthenticated();
      setIsAuthenticated(isValid);
      setIsChecking(false);
    };

    checkAuth();

    // Set up interval to check token validity periodically
    const interval = setInterval(() => {
      if (!authService.isAuthenticated()) {
        setIsAuthenticated(false);
      }
    }, 60000); // Check every minute

    return () => clearInterval(interval);
  }, []);

  // Show loading state while checking authentication
  if (isChecking) {
    return <ThemedSuspense />;
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    // Save the attempted location to redirect back after login
    return (
      <Navigate
        to="/vendor/login"
        state={{ from: location }}
        replace
      />
    );
  }

  // Render protected content
  return children;
};

export default ProtectedRoute;

